import { create } from "zustand"

import { BottomRightPopupData } from "@/components/dialog/BottomRightPopupClient"

interface UbBottomRightPopupState {
  currentPopupData: BottomRightPopupData | null
  setCurrentPopupData: (newPopupData: BottomRightPopupData | null) => void

  currentPopupShow: boolean
  setCurrentPopupShow: (newPopupShow: boolean) => void
  currentPopupCollapsed: boolean
  setCurrentPopupCollapsed: (newPopupCollapsed: boolean) => void
}

export const useUbBottomRightPopupState = create<UbBottomRightPopupState>(
  (set): UbBottomRightPopupState => ({
    currentPopupData: null,
    setCurrentPopupData: (newPopupData) => set(() => ({ currentPopupData: newPopupData })),

    currentPopupShow: false,
    setCurrentPopupShow: (newPopupShow: boolean) => set(() => ({ currentPopupShow: newPopupShow })),

    currentPopupCollapsed: false,
    setCurrentPopupCollapsed: (newPopupCollapsed: boolean) => set(() => ({ currentPopupCollapsed: newPopupCollapsed })),
  })
)
